import { StackFrame } from 'stacktrace-js'

export class MCMError extends Error {
  code: number | string
  stacktrace: StackFrame[]
}
